import { render } from "./pageMuseumEvent.vue?vue&type=template&id=53606aa2"
import script from "./pageMuseumEvent.vue?vue&type=script&lang=js"
export * from "./pageMuseumEvent.vue?vue&type=script&lang=js"

import "./pageMuseumEvent.vue?vue&type=style&index=0&id=53606aa2&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__